import {
  IS_PROD,
} from '@/config/index';

const GTM_BY_COUNTRY = {
  br: 'GTM-N3R6QP4',
  mx: 'GTM-N7XHBJK',
  es: '',
  cl: 'GTM-TM4R2MG',
  co: 'GTM-K6KPD77',
  ar: 'GTM-WZSHMR9M',
  pe: 'GTM-W73TBXML',
  ec: 'GTM-NL3VF7KD',
  do: 'GTM-KWG5KK39',
  bo: 'GTM-W6CVMW4Z',
  uy: 'GTM-5L36T9JN',
  homolog: 'GTM-5SXPV674',
};

export const getGTMByCountry = (country) => {
  const selectedCountry = IS_PROD ? country : 'homolog';
  return GTM_BY_COUNTRY[selectedCountry];
};
